/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import Modal from 'react-modal';
import { IPdfViewerProps, PdfViewer } from './pdfViewer';
import * as S from './styles';

export type IPdfViewerModalProps = {
  showModal: boolean;
} & IPdfViewerProps;

export const PdfViewerModal = ({
  showModal,
  ...rest
}: IPdfViewerModalProps) => {
  return (
    <Modal
      isOpen={showModal}
      style={S.ModalStyle}
      appElement={
        typeof global.window !== 'undefined'
          ? global.window.document.body
          : undefined
      }
    >
      <PdfViewer {...rest} />
    </Modal>
  );
};

PdfViewerModal.defaultProps = {
  showModal: false,
};
